import styled from "styled-components";

/**
 * Styled container for the Entrata Test Connection component
 */
export const TestConnectionContainer = styled.div`
  .entrata-test-connection {
    margin-bottom: 16px;
  }

  .test-connection-button {
    width: 100%;
    height: 40px;
    font-weight: 500;
    border-radius: 6px;
    transition: all 0.2s ease-in-out;

    &:hover:not(:disabled) {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    &:active:not(:disabled) {
      transform: translateY(0);
    }
  }

  .test-connection-hint {
    color: #6b7280;
    margin: 12px 0 20px 0;
    font-size: 14px;
    line-height: 1.5;
    text-align: center;
    font-style: italic;
    font-weight: 400;
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
  }

  .ant-alert {
    border-radius: 6px;
    border: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    &.ant-alert-success {
      background: linear-gradient(135deg, #f6ffed 0%, #f0f9e8 100%);
      border-left: 4px solid #52c41a;
    }

    &.ant-alert-error {
      background: linear-gradient(135deg, #fff2f0 0%, #ffe7e6 100%);
      border-left: 4px solid #ff4d4f;
    }

    .ant-alert-message {
      font-weight: 500;
      line-height: 1.5;
    }

    .ant-alert-icon {
      font-size: 16px;
    }
  }
`;

/**
 * Styled wrapper for the test connection feedback
 */
export const TestResultWrapper = styled.div`
  animation: slideIn 0.3s ease-out;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
